export const VALUATION_METHODS = {
  LADDER: 'ladder_v1',
  SIMILARITY_LEGACY: 'similarity_v1',
  SIMILARITY_ARITHMETIC: 'similarity_arithmetic_v1',
  SIMILARITY_MULTIPLICATIVE: 'similarity_multiplicative_v1',
}

export const SIMILARITY_METHOD_OPTIONS = [
  {
    id: VALUATION_METHODS.SIMILARITY_ARITHMETIC,
    label: 'Průměr faktorů',
    description: 'Vyváženější relevance',
  },
  {
    id: VALUATION_METHODS.SIMILARITY_MULTIPLICATIVE,
    label: 'Součin faktorů',
    description: 'Přísnější relevance',
  },
]

export const isSimilarityMethod = (method) =>
  [
    VALUATION_METHODS.SIMILARITY_LEGACY,
    VALUATION_METHODS.SIMILARITY_ARITHMETIC,
    VALUATION_METHODS.SIMILARITY_MULTIPLICATIVE,
  ].includes(method)

export const normalizeSimilarityMethod = (method) =>
  method === VALUATION_METHODS.SIMILARITY_MULTIPLICATIVE
    ? VALUATION_METHODS.SIMILARITY_MULTIPLICATIVE
    : VALUATION_METHODS.SIMILARITY_ARITHMETIC

export const getValuationMethodLabel = (method, storedLabel = null) => {
  if (storedLabel) return storedLabel
  if (method === VALUATION_METHODS.SIMILARITY_MULTIPLICATIVE) return 'Součin faktorů + vážená cena'
  if (isSimilarityMethod(method)) return 'Průměr faktorů + vážená cena'
  return 'Postupně rozšiřovaný žebříček v1'
}
